import React from "react";
import { Link } from "react-router-dom";

const LandingFooter = () => {
  return (
    <footer className="site-footer">
      <div className="footer-brand">
        <img src="/assets/rebel-logo.png" alt="Rebel" />
        <p>
          Built in The Bahamas.<br />
          Powered by creators worldwide.
        </p>
      </div>

      <div className="footer-column">
        <h3>Quick Links</h3>
        <Link to="/">Home</Link>
        <Link to="/howitworks" target="_blank">
          How It Works
        </Link>
        <Link to="/about" target="_blank">
          About Us
        </Link>
        <Link to="/events" target="_blank">
          Events
        </Link>
        <Link to="/creators" target="_blank">
          Creators
        </Link>
        <Link to="/contract" target="_blank">
          Standard Contract
        </Link>
      </div>

      <div className="footer-column">
        <h3>Support</h3>
        <Link to="/subscriber" target="_blank">
          Subscriber FAQ
        </Link>
        <Link to="/creator" target="_blank">
          Creator FAQ
        </Link>
        <Link to="/terms" target="_blank">
          Terms of Use
        </Link>
        <Link to="/privacy" target="_blank">
          Privacy Policy
        </Link>
      </div>

      <div className="footer-column">
        <h3>Follow Us</h3>
        <div className="socials">
          <a href="#" aria-label="Facebook">f</a>
          <a href="#" aria-label="Instagram">◎</a>
          <a href="#" aria-label="YouTube">▶</a>
          <a href="#" aria-label="TikTok">♪</a>
        </div>
      </div>

      <p className="copyright">
        © {new Date().getFullYear()} Chatana Media / Rebel Media Network. All rights reserved.
      </p>
    </footer>
  );
};

export default LandingFooter;
